/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import { type ReactNode } from "react";
import { FullScreenView } from "../FullScreenView";
import styles from "./RoomAccessNotice.module.css";

export function RoomAccessNotice({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <FullScreenView className={styles.page}>
      <section className={styles.card} role="alert">
        <span className={styles.icon} aria-hidden="true">
          i
        </span>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {action}
      </section>
    </FullScreenView>
  );
}
